'use es6';

import { createTracker } from 'usage-tracker';
import events from 'attribution-lib/events.yaml';
const DEFAULTS = {
  debug: false,
  events,
  lastKnownEventProperties: ['screen', 'subscreen'],
  onError: err => {
    throw err;
  },
  properties: {
    namespace: 'reporting'
  }
};
export const ACTIONS = {
  CHANGED_MODEL: 'changed model',
  OPENED_MODAL: 'opened modal',
  OPENED_BUILDER: 'opened builder',
  OPENED_DRILLDOWN: 'opened drilldown',
  CHANGED_DATE_RANGE: 'changed date range'
};
export const EVENTS = {
  REVENUE_ATTRIBUTION_CARD: 'revenueAttributionCard'
};
export default createTracker(DEFAULTS);